import {Injectable} from '@angular/core';
import {AuthHttpService} from "./auth-http.service";
import {ProposalRequest, ProposalResponse} from "../model/calculation/hecht-proposal.model";
import {Observable} from "rxjs";
import {optimistic} from "./common-http.service";

@Injectable({
  providedIn: 'root'
})
export class ProposalApiService {

  constructor(
    private authHttp: AuthHttpService
  ) { }

  calculateProposal(request: Array<ProposalRequest>): Observable<string> {
    return this.authHttp.post<string>("/proposal", request).pipe(optimistic);
  }
}
